<template>
    <v-container fill-height>
        <v-layout row>
            <v-flex xs12 sm10 md6 text-center>
                <v-row>
                    <v-col cols="12">
                        <qrcode-stream class="element" @decode="onDecode" @init="onInit"/>
                        <p class="error">{{ error }}</p>
                    </v-col>
                </v-row>
                <h1>{{ result }}</h1>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import EventBus from '@/EventBus'

export default {
    name: "BarcodeScanWaiting",
    data() {
        return {
            loading: false,
            result: '',
            error: '',
            camera: 'auto'
        }
    },
    mounted() {
        window.scrollTo(0, 0)
        EventBus.$emit('set_navigation', {title: 'QR CODE SCAN', back_route: 'waiting-parcel'})
    },
    watch: {
        result() {
            let parcel = this.getLocalItem();
            parcel.barcode = this.result
            localStorage.setItem('parcel', JSON.stringify(parcel))

            return this.$router.push({name: 'waiting-parcel'})
        }
    },
    methods: {
        onDecode(result) {
            this.result = result
        },
        async onInit(promise) {
            try {
                await promise
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    this.error = "ERROR: you need to grant camera access permisson"
                } else if (error.name === 'NotFoundError') {
                    this.error = "ERROR: no camera on this device"
                } else if (error.name === 'NotSupportedError') {
                    this.error = "ERROR: secure context required (HTTPS, localhost)"
                } else if (error.name === 'NotReadableError') {
                    this.error = "ERROR: is the camera already in use?"
                } else if (error.name === 'OverconstrainedError') {
                    this.error = "ERROR: installed cameras are not suitable"
                } else if (error.name === 'StreamApiNotSupportedError') {
                    this.error = "ERROR: Stream API is not supported in this browser"
                } else {
                    this.error = error.name
                }
            }
        }

    }
}
</script>

<style scoped>

</style>
